// Libraries
import type { FormikValues } from 'formik';
import { useFormik } from 'formik';
// Types
import { useFormProps } from './useForm.type';

/**
 * Custom hook for handling form state and validation using Formik.
 * @typeParam Values - The type of form values.
 * @param {useFormProps<Values>} props - The hook props.
 * @returns {FormikProps<Values>} The Formik context object.
 */
export const useForm = <Values extends FormikValues>(props: useFormProps<Values>) => {
  const formikCtx = useFormik({
    enableReinitialize: true,
    initialValues: props.initialValues,
    onSubmit: props.submitHandler,
    onReset: props.resetHandler,
    validationSchema: props.schema,
  });

  return formikCtx;
};
